import ApiClient from '../ApiClient';

class CetakersFlowLogsAPI extends ApiClient {
  constructor() {
    super('integrations/cetakers_flow_logs', { accountScoped: true });
  }

  getLogs() {
    return this.get('');
  }
}

export default new CetakersFlowLogsAPI();
